import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    templateUrl: './corporate-portal.component.html',
    styleUrls: ['./corporate-portal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CorporatePortalPageComponent {}
